// Paths
import { Routes } from '@angular/router';
import {
  AgentModulePaths,
  BaseModulePaths,
  BasePaths,
} from 'src/app/constants/routes';

// Guards
import { AgentSessionGuard } from 'src/app/guards/agent-session.guard';
import { MemberSessionGuard } from 'src/app/guards/member-session.guard';
import { LoginGuard } from 'src/app/guards/login.guard';
import { BenefitEnrollmentGuard } from '../guards/benefit-enrollment.guard';
import { USAePayGuard } from 'src/app/guards/usaepay.guard';
import { AccountGuard } from 'src/app/guards/account.guard';
import { ACAGuard } from 'src/app/guards/aca.guard';
import { QLEGuard } from 'src/app/guards/qle.guard';
import { PayrollGuard } from '../guards/payroll.guard';
import { MemberPayrollHyperlinkGuard } from '@app/guards/member-hyperlink.guard';

// Base Components
import { PageNotFoundComponent } from 'src/app/components/page-not-found.component';
import { LoginComponent } from 'src/app/components/login/login.component';
import { VersionErrorComponent } from 'src/app/components/version-error.component';
import { ValidateAndCreatePasswordComponent } from '../components/login/validate-and-create-password.component';
import { RegisterComponent } from '../components/login/components/register.component';
import { PrivacyPolicyComponent } from '../components/shared/documents/privacy-policy.component';
import { TermsOfServiceComponent } from '../components/shared/documents/terms-of-service.component';
import { DataProcessingAddendumComponent } from '../components/shared/documents/data-processing-addendum.component';


const BaseComponents = [
  LoginComponent,
  PageNotFoundComponent,
  ValidateAndCreatePasswordComponent,
  VersionErrorComponent,
  RegisterComponent,
  PrivacyPolicyComponent,
  DataProcessingAddendumComponent,
]

const BaseRoutes: Routes = [
  {
    path: BaseModulePaths.Home,
    redirectTo: BasePaths.Members,
    pathMatch: 'full',
  },
  {
    path: BaseModulePaths.Members,
    component: LoginComponent,
    canActivate: [MemberPayrollHyperlinkGuard, LoginGuard],
  },
  {
    path: BaseModulePaths.Counselors,
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: `${BaseModulePaths.FirstResponders}/:comCode`,
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: BaseModulePaths.ResetPassword,
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: BaseModulePaths.ValidatePassword,
    component: ValidateAndCreatePasswordComponent,
    canActivate: [LoginGuard],
  },
  {
    path: BaseModulePaths.ValidateEmail,
    component: ValidateAndCreatePasswordComponent,
    canActivate: [LoginGuard],
  },
  {
    path: BaseModulePaths.ValidateAgentPassword,
    component: ValidateAndCreatePasswordComponent,
    canActivate: [LoginGuard],
  },
  {
    path: BaseModulePaths.AgentPasswordExpired,
    component: ValidateAndCreatePasswordComponent,
    canActivate: [LoginGuard],
  },
  {
    path: BaseModulePaths.Register,
    component: LoginComponent,
  },
  {
    path: BaseModulePaths.AccountDeleted,
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: BaseModulePaths.Passthrough,
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: BaseModulePaths.PrivacyPolicy,
    component: PrivacyPolicyComponent,
  },
  {
    path: BaseModulePaths.TermsOfService,
    component: TermsOfServiceComponent,
  },
  {
    path: BaseModulePaths.DataProcessingAddendum,
    component: DataProcessingAddendumComponent,
  },
];

const EndRoute: Routes = [
  {
    path: BaseModulePaths.VersionError,
    component: VersionErrorComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

// Configurations
import {
  AgentComponents,
  Agent1MemberRoutes,
  //Agent2CallLogRoutes,
  //Agent3FollowUpsRoutes,
  Agent4ResourcesRoutes,
  Agent5ReportsRoutes,
  Agent6AgentsRoutes,
} from 'src/app/modules/routing/agent-route.module';

import {
  MemberComponents,
  Member1DashboardRoutes,
  Member2BenefitRoutes,
  Member3ProfileRoutes,
  Member4AccountingRoutes,
  Member5DocumentsRoutes,
  //Member6RelationsRoutes,
  Member7PayrollRoutes,
} from 'src/app/modules/routing/member-route.module';

// Exports
export const RoutingGuards = [
  AgentSessionGuard,
  MemberSessionGuard,
  LoginGuard,
  BenefitEnrollmentGuard,
  USAePayGuard,
  AccountGuard,
  ACAGuard,
  QLEGuard,
  PayrollGuard,
  MemberPayrollHyperlinkGuard
];

export const RoutingComponents = [
  BaseComponents,
  AgentComponents,
  MemberComponents,
];

export const RoutingRoutes = BaseRoutes.concat(
  Agent1MemberRoutes,
  //Agent2CallLogRoutes,
  //Agent3FollowUpsRoutes,
  Agent4ResourcesRoutes,
  Agent5ReportsRoutes,
  Agent6AgentsRoutes,
  Member1DashboardRoutes,
  Member2BenefitRoutes,
  Member3ProfileRoutes,
  Member4AccountingRoutes,
  Member5DocumentsRoutes,
  //Member6RelationsRoutes,
  Member7PayrollRoutes,
  EndRoute // NotFound Needs to be Last otherwise any routes below will fail
);
